import React from 'react';
// Import routing components
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 

// Import your components
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import './App.css';

// IMPORTANT: 
// The footer from your previous steps must now be included in the 
// About, Services, Projects, and Contact components to be "common to all pages,"
// as they are no longer loading inside the Home component's main scroll view.

function App() {
  return (
    // 1. BrowserRouter enables the URL-based navigation
    <BrowserRouter>
      {/* 2. Routes conditionally render components based on the URL */}
      <Routes>
        
        {/* The Home page at the root URL: http://yourdomain.com/ */}
        <Route path="/" element={<Home />} />
        
        {/* Full-screen pages accessed via URL: http://yourdomain.com/about */}
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />

        {/* Optional: Add a 404/Catch-all route */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;